import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import InsumoRecord from '@components/InsumoRecord/InsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';

/**
 * Componente para tela de Fungicidas
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function Fungicidas(props) {
  useEffect(() => {
    const title = 'fungicida.fungicida';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <InsumoRecord
      chipData={props.chipData}
      infoUsuario={props.infoUsuario}
      insumoEnum={Insumo.FUNGICIDA}
      insumoURL='fungicidas'
      viewKey='fungicidas'
      deleteMessageSucess={formatMessage(
        'fungicida.fungicidaRemovidoComSucesso'
      )}
      mensagemFalhaDeletar={formatMessage('fungicida.falhaAoExcluirFungicida')}
      mensagemDelete={formatMessage('fungicida.desejaExcluir')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info,
  chipData: state.chips.chipData.filter(date => {
    return date.id === 'fungicidas';
  })[0].content
});

export default connect(mapStateToProps)(Fungicidas);
